import { MOBILE_HISTORY_INFO_TYPES } from "./mobileHistoryConstants";
import MobileHistoryDateRow from "./MobileHistoryDateRow/MobileHistoryDateRow";
import MobileHistoryTransactionRow
    from "./MobileHistoryTransaction/MobileHistoryTransactionRow/MobileHistoryTransactionRow";
import { Virtuoso } from "react-virtuoso";
import moment from "moment/moment";
import { MOBILE_SLIDER_PAGES_IDS } from "../MobileSliderPages/mobileSliderPagesConstants";
import { Fragment, useCallback, useEffect, useMemo, useState } from "react";
import { createStructuredSelector } from "reselect";
import { getUserSelectedAccountCode } from "../../../app/appSelectors";
import { getAccountHistory } from "../../../modules/Account/accountSelectors";
import { openMobileSliderPageAction } from "../../mobileAppActions";
import {
    payoutGetTransactionsAction,
    setAccountSelectedHistoryInfoAction
} from "../../../modules/Account/accountActions";
import { connect } from "react-redux";
import { loadAccountHistoryAction } from "../../../app/appActions";
import _ from "lodash";
import MobileHistoryPositionRow from "./MobileHistoryPosition/MobileHistoryPositionRow";
import { MobileHistoryFilterContainerStyled } from "./styled/MobileHistoryStyled";
import classNames from "classnames";
import { Button } from "react-bootstrap";
import { useLangContext } from "../../../providers/LangProvider/LangProviderContext";
import MobileHistoryEmpty from "./MobileHistoryEmpty";

function MobileHistory(props) {
    const {
        loadAccountHistory,
        openMobileSliderPage,
        selectedAccountCode,
        setAccountHistoryItem,
        history,
    } = props;
    const {getLangPath} = useLangContext();
    const [selectedFilterType, setSelectedFilterType] = useState('all');

    useEffect(() => {
        if (selectedAccountCode) {
            loadAccountHistory(selectedAccountCode);
        }
    }, [loadAccountHistory, selectedAccountCode]);

    const historyRowsToRender = useMemo(() => {
        let currentDate;
        const positions = ['all', MOBILE_HISTORY_INFO_TYPES.POSITION].includes(selectedFilterType) ? history.positions?.map(position => ({
            ...position,
            infoType: MOBILE_HISTORY_INFO_TYPES.POSITION,
            infoDate: position.last_update_time || position.open_time,
        })) || [] : [];
        const transactions = ['all', MOBILE_HISTORY_INFO_TYPES.TRANSACTION].includes(selectedFilterType) ? history.transactions?.map(transaction => ({
            ...transaction,
            infoType: MOBILE_HISTORY_INFO_TYPES.TRANSACTION,
            infoDate: transaction.created_at,
        })) || [] : [];

        return _.sortBy([...positions, ...transactions], 'infoDate').reverse().reduce((accum, info) => {
            const dateMoment = moment(info.infoDate)
            const day = dateMoment.format('MMMM, D');
            const time = dateMoment.format('HH:mm:ss');
            const transactionItem = {
                ...info,
                formattedDate: time,
            };
            if (currentDate !== day) {
                currentDate = day;
                return accum.concat({
                    infoType: MOBILE_HISTORY_INFO_TYPES.DATE,
                    formattedDate: day,
                }, transactionItem);
            } else {
                return accum.concat(transactionItem);
            }
        }, []);
    }, [history, selectedFilterType]);

    const handleItemClick = useCallback(({id, type, item}) => {
        setAccountHistoryItem(item);
        openMobileSliderPage({name: MOBILE_SLIDER_PAGES_IDS.HISTORY_INFO, id, type});
    }, [openMobileSliderPage, setAccountHistoryItem]);

    const handleAssetTypeClick = useCallback((e) => {
        const filterType = e.currentTarget.dataset.type;
        setSelectedFilterType(filterType);
    }, []);

    return <>
        {!historyRowsToRender.length && <MobileHistoryEmpty/>}
        {historyRowsToRender.length > 0 && <>
            <MobileHistoryFilterContainerStyled className="gap-2 px-3">
                {
                    ['all', MOBILE_HISTORY_INFO_TYPES.POSITION, MOBILE_HISTORY_INFO_TYPES.TRANSACTION].map((filterType) =>
                        <Fragment key={filterType}>
                            <Button
                                variant={'info'}
                                size={'sm'}
                                data-type={filterType}
                                onClick={handleAssetTypeClick}
                                className={classNames({'selected': selectedFilterType === filterType})}
                            >
                                {getLangPath(`lite_version.history.filter_types.${filterType}`, {}, {emptyDefault: true}) || filterType}
                            </Button>
                        </Fragment>)
                }
            </MobileHistoryFilterContainerStyled>
            <Virtuoso
                increaseViewportBy={400}
                style={{height: '100%'}}
                data={historyRowsToRender}
                itemContent={(index, item) => {
                    switch (item.infoType) {
                        case MOBILE_HISTORY_INFO_TYPES.DATE:
                            return <MobileHistoryDateRow item={item}/>
                        case MOBILE_HISTORY_INFO_TYPES.POSITION:
                            return <MobileHistoryPositionRow item={item}/>
                        default:
                            return <MobileHistoryTransactionRow item={item} onClick={handleItemClick}/>
                    }
                }
                }
            />
        </>}
    </>
}

const mapStateToProps = createStructuredSelector({
    history: getAccountHistory,
    selectedAccountCode: getUserSelectedAccountCode,
});

const mapDispatchToProps = (dispatch) => ({
    loadAccountHistory: payload => dispatch(loadAccountHistoryAction(payload)),
    openMobileSliderPage: payload => dispatch(openMobileSliderPageAction(payload)),
    payoutGetTransactions: payload => dispatch(payoutGetTransactionsAction(payload)),
    setAccountHistoryItem: payload => dispatch(setAccountSelectedHistoryInfoAction(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(MobileHistory);
